import { handle420 } from 'apis/HandleError';
import { fetchdata } from './FetchData';
import { apiConfig } from 'config';

export function getBulkSoftwareDetails(bulkSwUpdateId) {
  return fetchdata(apiConfig.cmServiceGetBulkSoftwareDetails(bulkSwUpdateId), { method: 'GET' })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
